import React from 'react'

import './table-header-cell.scss'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

import sortAscIcon from '../../../../commons/src/assets/icons/sort-asc.svg'
import sortDescIcon from '../../../../commons/src/assets/icons/sort-desc.svg'
import sortIcon from '../../../../commons/src/assets/icons/sort.svg'

import Icon from '../../../../commons/src/components/icon'

type Props<T extends React.ElementType> = Overwrite<
  CommonProps<T>,
  {
    as?: T
    children?: React.ReactNode
    width?: number | string
    computedWidth?: string
    align?: 'left' | 'center' | 'right'
    sort?: 'asc' | 'desc'
    onClick?: React.MouseEventHandler
    groupChild?: boolean
    firstCell?: boolean
    lastCell?: boolean
    noBorder?: boolean
  }
>

const sortIconMap = {
  asc: sortAscIcon,
  desc: sortDescIcon,
}

const TableHeaderCell = <T extends React.ElementType = 'div'>({
  as,
  className,
  children,
  computedWidth: width,
  align = 'left',
  sort,
  firstCell = false,
  lastCell = false,
  noBorder = false,
  ...props
}: Props<T>) => {
  const sortable = !!props.onClick

  const Root = (as ?? (sortable ? 'button' : 'div')) as React.ElementType

  return (
    <Root
      type={Root === 'button' ? 'button' : undefined}
      {...props}
      className={cn(
        'TableHeaderCell',
        {
          [`align-${align}`]: !!align,
          fixed: !!width && width.includes('px'),
          sortable,
          sort: !!sort,
          firstCell,
          lastCell,
          noBorder,
        },
        className
      )}
      style={{...(props.style ?? {}), width}}
    >
      <span className="TableHeaderCell__content">{children}</span>
      {sortable && (
        <span className="TableHeaderCell__sort">
          <Icon source={sort ? sortIconMap[sort] : sortIcon} />
        </span>
      )}
    </Root>
  )
}

export default TableHeaderCell
